import { Button } from 'components/atoms/Button';
import AppleIncIcon from 'components/atoms/SVG/AppleIncIcon.component';
import type { FC } from 'react';
import AppleLogin from 'react-apple-login';
import { logAmplitude } from 'utils/amplitude';
import { isDomainBE, isDomainDE } from 'utils/constants';

const redirectURL = isDomainDE
  ? import.meta.env.VITE_APP_APPLE_REDIRECT_URL_DE
  : isDomainBE
  ? import.meta.env.VITE_APP_APPLE_REDIRECT_URL_BE
  : import.meta.env.VITE_APP_APPLE_REDIRECT_URL;

const AppleAuthButton: FC<{
  onSuccess: any;
  label?: string;
  tracingEvent: string;
}> = ({ onSuccess, label, tracingEvent }) => (
  <AppleLogin
    clientId={import.meta.env.VITE_APP_APPLE_CLIENTID as string}
    redirectURI={redirectURL as string}
    scope="email name"
    responseMode="form_post"
    responseType="code id_token"
    usePopup
    callback={async (response) => {
      if (response.error) return;

      await onSuccess(response);
    }}
    render={(props) => (
      <Button
        structure="light"
        onClick={(e) => {
          props.onClick(e);

          logAmplitude(tracingEvent);
        }}
        className="flex items-center justify-center bg-white border border-primary-100 rounded-full h-12 w-full hover:bg-gray-50 transition-colors mb-2"
      >
        <div className="w-[20px] ml-[10px]">
          <AppleIncIcon />
        </div>

        <p className="text-primary-700 font-semibold pl-1">
          {label || 'Sign in with Apple'}
        </p>
      </Button>
    )}
  />
);

export default AppleAuthButton;
